/**
 * Published /work-cafes/:city landing pages, for static internal links in the
 * shared Footer.
 *
 * GENERATED FILE. Written by scripts/generate-sitemap.ts on predev and
 * prebuild, from the same published city pages the sitemap and the prerender
 * route list use. Do not edit by hand: publish the city page instead and the
 * next build picks it up.
 */
export const CITY_PAGE_LINKS: { slug: string; name: string }[] = [
  { slug: "los-angeles", name: "Los Angeles" },
  { slug: "santa-monica", name: "Santa Monica" },
  { slug: "pasadena", name: "Pasadena" },
  { slug: "koreatown", name: "Koreatown" },
  { slug: "hollywood", name: "Hollywood" },
  { slug: "westwood", name: "Westwood" },
];
